/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_TitleInputs */

const en_settings_billing_title = /** @type {(inputs: Settings_Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

const zh_settings_billing_title = /** @type {(inputs: Settings_Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账单`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Settings_Billing_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_title = /** @type {((inputs?: Settings_Billing_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_title(inputs)
	return zh_settings_billing_title(inputs)
});
export { settings_billing_title as "settings.billing.title" }